/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AuthorisationCode} from '../models/AuthorisationCode';
import type {CredentialsUpdateResult} from '../models/CredentialsUpdateResult';
import type {Error} from '../models/Error';
import type {HubspotAccountSettings} from '../models/HubspotAccountSettings';

export interface CleanupHubspotOAuthCredentials$Request {
    accountId: number;
}

export interface CleanupHubspotOAuthCredentials$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const cleanupHubspotOAuthCredentialsRequest = createAction<PayloadData<void, CleanupHubspotOAuthCredentials$Request>>('HUBSPOT_CONTROLLER__CLEANUP_HUBSPOT_O_AUTH_CREDENTIALS__REQUEST');
export const cleanupHubspotOAuthCredentialsSuccess = createAction<PayloadData<void, CleanupHubspotOAuthCredentials$Request>>('HUBSPOT_CONTROLLER__CLEANUP_HUBSPOT_O_AUTH_CREDENTIALS__SUCCESS');
export const cleanupHubspotOAuthCredentialsFailure = createAction<PayloadData<Error, CleanupHubspotOAuthCredentials$Request, true>>('HUBSPOT_CONTROLLER__CLEANUP_HUBSPOT_O_AUTH_CREDENTIALS__FAILURE');

export const cleanupHubspotOAuthCredentialsActions = [
    cleanupHubspotOAuthCredentialsRequest,
    cleanupHubspotOAuthCredentialsSuccess,
    cleanupHubspotOAuthCredentialsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const cleanupHubspotOAuthCredentials = (meta: CleanupHubspotOAuthCredentials$Request, config?: CleanupHubspotOAuthCredentials$Config) => {
    return {
        CALL_API: {
            types: cleanupHubspotOAuthCredentialsActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/crm/${meta.accountId}/hubspot/credentials-oauth`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetHubspotCredentialsOauth$Request {
    accountId: number;
}

export interface GetHubspotCredentialsOauth$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getHubspotCredentialsOauthRequest = createAction<PayloadData<void, GetHubspotCredentialsOauth$Request>>('HUBSPOT_CONTROLLER__GET_HUBSPOT_CREDENTIALS_OAUTH__REQUEST');
export const getHubspotCredentialsOauthSuccess = createAction<PayloadData<AuthorisationCode, GetHubspotCredentialsOauth$Request>>('HUBSPOT_CONTROLLER__GET_HUBSPOT_CREDENTIALS_OAUTH__SUCCESS');
export const getHubspotCredentialsOauthFailure = createAction<PayloadData<Error, GetHubspotCredentialsOauth$Request, true>>('HUBSPOT_CONTROLLER__GET_HUBSPOT_CREDENTIALS_OAUTH__FAILURE');

export const getHubspotCredentialsOauthActions = [
    getHubspotCredentialsOauthRequest,
    getHubspotCredentialsOauthSuccess,
    getHubspotCredentialsOauthFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getHubspotCredentialsOauth = (meta: GetHubspotCredentialsOauth$Request, config?: GetHubspotCredentialsOauth$Config) => {
    return {
        CALL_API: {
            types: getHubspotCredentialsOauthActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/crm/${meta.accountId}/hubspot/credentials-oauth`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetHubspotCrmSettings$Request {
    accountId: number;
}

export interface GetHubspotCrmSettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getHubspotCrmSettingsRequest = createAction<PayloadData<void, GetHubspotCrmSettings$Request>>('HUBSPOT_CONTROLLER__GET_HUBSPOT_CRM_SETTINGS__REQUEST');
export const getHubspotCrmSettingsSuccess = createAction<PayloadData<HubspotAccountSettings, GetHubspotCrmSettings$Request>>('HUBSPOT_CONTROLLER__GET_HUBSPOT_CRM_SETTINGS__SUCCESS');
export const getHubspotCrmSettingsFailure = createAction<PayloadData<Error, GetHubspotCrmSettings$Request, true>>('HUBSPOT_CONTROLLER__GET_HUBSPOT_CRM_SETTINGS__FAILURE');

export const getHubspotCrmSettingsActions = [
    getHubspotCrmSettingsRequest,
    getHubspotCrmSettingsSuccess,
    getHubspotCrmSettingsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getHubspotCrmSettings = (meta: GetHubspotCrmSettings$Request, config?: GetHubspotCrmSettings$Config) => {
    return {
        CALL_API: {
            types: getHubspotCrmSettingsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/crm/${meta.accountId}/hubspot/settings`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface HubspotCredentialsCheck$Request {
    accountId: number;
}

export interface HubspotCredentialsCheck$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const hubspotCredentialsCheckRequest = createAction<PayloadData<void, HubspotCredentialsCheck$Request>>('HUBSPOT_CONTROLLER__HUBSPOT_CREDENTIALS_CHECK__REQUEST');
export const hubspotCredentialsCheckSuccess = createAction<PayloadData<CredentialsUpdateResult, HubspotCredentialsCheck$Request>>('HUBSPOT_CONTROLLER__HUBSPOT_CREDENTIALS_CHECK__SUCCESS');
export const hubspotCredentialsCheckFailure = createAction<PayloadData<Error, HubspotCredentialsCheck$Request, true>>('HUBSPOT_CONTROLLER__HUBSPOT_CREDENTIALS_CHECK__FAILURE');

export const hubspotCredentialsCheckActions = [
    hubspotCredentialsCheckRequest,
    hubspotCredentialsCheckSuccess,
    hubspotCredentialsCheckFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const hubspotCredentialsCheck = (meta: HubspotCredentialsCheck$Request, config?: HubspotCredentialsCheck$Config) => {
    return {
        CALL_API: {
            types: hubspotCredentialsCheckActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/crm/${meta.accountId}/hubspot/credentials-check`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SaveHubspotCredentials$Request {
    accountId: number;
    authorizationCode: string;
}

export interface SaveHubspotCredentials$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveHubspotCredentialsRequest = createAction<PayloadData<void, SaveHubspotCredentials$Request>>('HUBSPOT_CONTROLLER__SAVE_HUBSPOT_CREDENTIALS__REQUEST');
export const saveHubspotCredentialsSuccess = createAction<PayloadData<CredentialsUpdateResult, SaveHubspotCredentials$Request>>('HUBSPOT_CONTROLLER__SAVE_HUBSPOT_CREDENTIALS__SUCCESS');
export const saveHubspotCredentialsFailure = createAction<PayloadData<Error, SaveHubspotCredentials$Request, true>>('HUBSPOT_CONTROLLER__SAVE_HUBSPOT_CREDENTIALS__FAILURE');

export const saveHubspotCredentialsActions = [
    saveHubspotCredentialsRequest,
    saveHubspotCredentialsSuccess,
    saveHubspotCredentialsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {string} meta.authorizationCode
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveHubspotCredentials = (meta: SaveHubspotCredentials$Request, config?: SaveHubspotCredentials$Config) => {
    const TRANSPORT_GET_PARAMS = {
        authorizationCode: meta.authorizationCode,
    };
    return {
        CALL_API: {
            types: saveHubspotCredentialsActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/crm/${meta.accountId}/hubspot/credentials-oauth`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SaveHubspotCrmSettings$Request {
    accountId: number;
    hubspotAccountSettings?: HubspotAccountSettings;
}

export interface SaveHubspotCrmSettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveHubspotCrmSettingsRequest = createAction<PayloadData<void, SaveHubspotCrmSettings$Request>>('HUBSPOT_CONTROLLER__SAVE_HUBSPOT_CRM_SETTINGS__REQUEST');
export const saveHubspotCrmSettingsSuccess = createAction<PayloadData<void, SaveHubspotCrmSettings$Request>>('HUBSPOT_CONTROLLER__SAVE_HUBSPOT_CRM_SETTINGS__SUCCESS');
export const saveHubspotCrmSettingsFailure = createAction<PayloadData<Error, SaveHubspotCrmSettings$Request, true>>('HUBSPOT_CONTROLLER__SAVE_HUBSPOT_CRM_SETTINGS__FAILURE');

export const saveHubspotCrmSettingsActions = [
    saveHubspotCrmSettingsRequest,
    saveHubspotCrmSettingsSuccess,
    saveHubspotCrmSettingsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {HubspotAccountSettings} [meta.hubspotAccountSettings]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveHubspotCrmSettings = (meta: SaveHubspotCrmSettings$Request, config?: SaveHubspotCrmSettings$Config) => {
    return {
        CALL_API: {
            types: saveHubspotCrmSettingsActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/crm/${meta.accountId}/hubspot/settings`,
            TRANSPORT_REQUEST_BODY: meta.hubspotAccountSettings,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UnlinkHubspotOrgId$Request {
    accountId: number;
}

export interface UnlinkHubspotOrgId$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const unlinkHubspotOrgIdRequest = createAction<PayloadData<void, UnlinkHubspotOrgId$Request>>('HUBSPOT_CONTROLLER__UNLINK_HUBSPOT_ORG_ID__REQUEST');
export const unlinkHubspotOrgIdSuccess = createAction<PayloadData<void, UnlinkHubspotOrgId$Request>>('HUBSPOT_CONTROLLER__UNLINK_HUBSPOT_ORG_ID__SUCCESS');
export const unlinkHubspotOrgIdFailure = createAction<PayloadData<Error, UnlinkHubspotOrgId$Request, true>>('HUBSPOT_CONTROLLER__UNLINK_HUBSPOT_ORG_ID__FAILURE');

export const unlinkHubspotOrgIdActions = [
    unlinkHubspotOrgIdRequest,
    unlinkHubspotOrgIdSuccess,
    unlinkHubspotOrgIdFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const unlinkHubspotOrgId = (meta: UnlinkHubspotOrgId$Request, config?: UnlinkHubspotOrgId$Config) => {
    return {
        CALL_API: {
            types: unlinkHubspotOrgIdActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/crm/${meta.accountId}/hubspot/org-ids`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

